import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import imgLogo from '@img/Homepage/UWs-logo/white.png';
import imgLogo500 from '@img/Homepage/UWs-logo/white-500.png';
import imgLogo800 from '@img/Homepage/UWs-logo/white-800.png';
import imgLogo1080 from '@img/Homepage/UWs-logo/white-1080.png';
import imgLogo1600 from '@img/Homepage/UWs-logo/white-1600.png';
import { globalActions } from '@reducers/global';

const strSrc = `${imgLogo500} 500w, ${imgLogo800} 800w, ${imgLogo1080} 1080w, ${imgLogo1600} 1600w, ${imgLogo} 1647w`;

const Sidebar = () => {
	const dispatch = useDispatch(),
		captureError = ex => dispatch(globalActions.captureError(ex)),
		[shown, setShown] = useState(false);

	function onToggle(e) {
		e.preventDefault();

		try {
			if (!shown) setShown(true);

			if (document.documentElement.classList.contains('nav-open')) {
				document.documentElement.classList.toggle('nav-open');
				document.querySelectorAll('#bodyClick').forEach(e => e.remove());
			} else {
				document.documentElement.classList.toggle('nav-open');

				let node = document.createElement('div');

				node.id = 'bodyClick';
				node.onclick = _e => {
					if (_e.target.parentElement) _e.target.parentElement.removeChild(_e.target);

					document.querySelectorAll('#bodyClick').forEach(elem => elem.remove());
					document.documentElement.classList.toggle('nav-open');
				};

				document.body.appendChild(node);
			}
		} catch (ex) {
			captureError(ex);
		}
	}

	return (
		<div
			data-collapse='medium'
			data-animation='default'
			data-duration='400'
			data-easing='ease-out'
			data-easing2='ease-out'
			className='nav-2-columns w-nav'>
			<div className='navigation-container'>
				<a href='/' className='logo w-inline-block'>
					<img
						src={imgLogo}
						width='100'
						srcSet={strSrc}
						sizes='(max-width: 479px) 55vw, (max-width: 991px) 200px, 100vw'
						alt=''
						className='image-3'
					/>
				</a>
				<div className='menu-button w-nav-button'>
					<div className='icon-2 w-icon-nav-menu' onClick={onToggle} />
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
